import React from 'react'
import Modal from 'react-modal'
import { useFormik } from 'formik'
import moment from 'moment'
import { Button, FormGroup, FormInput, FormCheckbox } from 'shards-react'
import { commissionCreateActions, commissionUpdateActions } from '../../../../redux/reducers/Commission/commissionReducer'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'


const isValidDate = (d) => d instanceof Date && !isNaN(d)

const validationSchema = Yup.object().shape({
  date_from: Yup.date().required('Дата начала обязательна'),
  date_to: Yup.date()
    .required('Дата окончания обязательна')
    .when('date_from', (date_from, schema) =>
      isValidDate(date_from)
        ? schema
            .min(date_from, 'Дата окончания не может быть раньше даты начала')
            .test('same-year', 'Год должен совпадать с датой начала', function (value) {
              return !value || new Date(value).getFullYear() === date_from.getFullYear()
            })
        : schema,
    ),
  date_to_guk: Yup.date()
    .required('Дата окончания (ГУК) обязательна')
    .when(['date_from', 'date_to'], (date_from, date_to, schema) => {
      let s = schema
      if (isValidDate(date_from)) {
        s = s
          .min(date_from, 'Дата окончания (ГУК) не может быть раньше даты начала')
          .test('same-year-guk', 'Год должен совпадать с датой начала', function (value) {
            return !value || new Date(value).getFullYear() === date_from.getFullYear()
          })
      }
      if (isValidDate(date_to)) {
        s = s.min(date_to, 'Дата окончания (ГУК) не может быть раньше даты окончания')
      }
      return s
    }),
})


const modalStyles = {
  content: {
    inset: '15vh 30vw',
    padding: 0,
    borderRadius: '5px',
    overflow: 'visible',
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}


const initialValues = {
  date_from: '',
  date_to: '',
  date_to_guk: '',
  phone: '',
  closed: false,
}

const AddEditModal = ({ isOpen, onClose, isEdit, data }) => {

  const dispatch = useDispatch()

  const createItemHandler = ({closed, ...values}) => {
    const payload = {...values, closed: closed ? '1' : '0'}
    dispatch(commissionCreateActions.commissionCreateRequestStart(payload))
    onClose()
  }
  
  const updateItemHandler = ({created_at, closed, ...values}) => {
    const payload = {...values, closed: closed ? '1' : '0'}
    dispatch(commissionUpdateActions.commissionUpdateRequestStart(payload))
    onClose()
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: isEdit ? data : initialValues,
    validationSchema,
    validateOnBlur: true,
    onSubmit: isEdit ? updateItemHandler : createItemHandler
  })

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div style={{ backgroundColor: '#4c6fb6', padding: '10px 15px', borderRadius: '5px 5px 0 0' }}>
        <span style={{ color: '#fff', fontSize: '15px', fontWeight: 500 }}>
          {isEdit ? 'Редактирование комиссии' : 'Добавление комиссии'}
        </span>
      </div>

      <form onSubmit={formik.handleSubmit} style={{ padding: '20px', display: 'flex', flexDirection: 'column', height: 'calc(100% - 41px)' }}>
        <FormGroup>
          <label>Дата начала</label>
          <FormInput
            type="date"
            name="date_from"
            invalid={formik.touched.date_from && !!formik.errors.date_from}
            value={formik.values.date_from}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.date_from && formik.errors.date_from && (
            <small style={{ color: '#c4183c' }}>{formik.errors.date_from}</small>
          )}
        </FormGroup>

        <FormGroup>
          <label>Дата окончания</label>
          <FormInput
            type="date"
            name="date_to"
            invalid={formik.touched.date_to && !!formik.errors.date_to}
            value={formik.values.date_to}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.date_to && formik.errors.date_to && (
            <small style={{ color: '#c4183c' }}>{formik.errors.date_to}</small>
          )}
        </FormGroup>

        <FormGroup>
          <label>Дата окончания (ГУК)</label>
          <FormInput
            type="date"
            name="date_to_guk"
            invalid={formik.touched.date_to_guk && !!formik.errors.date_to_guk}
            value={formik.values.date_to_guk}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.date_to_guk && formik.errors.date_to_guk && (
            <small style={{ color: '#c4183c' }}>{formik.errors.date_to_guk}</small>
          )}
        </FormGroup>

        <FormGroup>
          <label>Номер телефона</label>
          <FormInput
            type="text"
            name="phone"
            placeholder="Введите номер телефона"
            value={formik.values.phone}
            onChange={formik.handleChange}
          />
        </FormGroup>

        <FormGroup>
          <FormCheckbox
            checked={formik.values.closed}
            onChange={() => formik.setFieldValue('closed', !formik.values.closed)}
          >
            Не отображать
          </FormCheckbox>
        </FormGroup>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: 'auto', paddingTop: '15px' }}>
          <Button type="button" theme="light" onClick={onClose}>Отменить</Button>
          <Button type="submit" theme="primary">
            {isEdit ? 'Сохранить' : 'Создать'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default AddEditModal
